<template>
	<div id="Main">
		<div class="imgbox">
			<div class="title">
				<p class="p1">上传材料</p>
				<p class="p2" v-if="type==2">请拍照上传与[过户原因]相关的证明材料</p>
				<p class="p2" v-if="type==4">请拍照上传市场监管局出具的股权出质设立登记通知书</p>
				<p class="p2" v-if="type==5">请拍照上传市场监管局出具的股权出质注销登记通知书</p>
				<p class="p2">可上传多张图片</p>
			</div>
			<div class="uploadbox">
				<van-uploader class="Positive" :preview-image="false" v-model="Positive" preview-size="100%">
					<van-image width="100%" fit="contain" :src="require('../assets/images/service/loader.png')" />
				</van-uploader>
			</div>
			<van-row type="flex" class="loaderbox">
				<van-col class="loaderimg" v-for="(item,index) in Positive" :key="index">
					<div class="pos">
						<van-icon name="clear" class="del" @click="del(index)"/>
						<van-image width="100%" height="100%" fit="contain" :src="item.content" />
					</div>
				</van-col>
			</van-row>
			<van-button round type="info" class="submit" @click="submit">下一步</van-button>
		</div>
	</div>
</template>
<script>
	import axiosPost from '../libs/moudle/index.js';
	export default {
		name: 'transfer',
		props:{
			type: { /* 类型 */
				type: [Number, String],
				default:1,
			},
		},
		data() {
			return {
				Positive:[],
				img:[],
				uploadimg:0,
				tpsat:''
			}
		},
		watch:{
			uploadimg(val){
				window.console.log(val)
				window.console.log(this.Positive)
				if(val==this.Positive.length){/* 全部图片上传完了提交所有数据 */
					this.tpsat.clear();
					this.$emit('submit',this.img)
				}
			}
		},
		methods: {
			del(index){/* 删除图片 */
				this.Positive.splice(index,1)
			},
			submit() {/* 提交 */
				if(this.Positive.length==0){
					this.$toast('请上传材料')
					return false;
				}
				this.tpsat=this.$toast.loading({
					message: '上传中...',
					forbidClick: true,
					duration: 0
				});
				if(this.Positive.length>0){
					this.Positive.forEach((item)=>{
						this.upload(item)
					})
				}
			},
			upload(val){/* 文件上传 */
				let formData = new FormData()
				formData.append('myFiles', val.file)
				axiosPost.upload(formData).then((res) => {
					window.console.log(res.data)
					if (res.data.code == 200) {
						this.uploadimg++;
						this.img.push(res.data.data)
					} else {
						this.$toast('上传失败，请重新上传！')
						this.img=[]
					}
				}).catch((res) => {
					window.console.log(res)
				})
			}
		},
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		text-align: left;
		min-height: 100vh;
		background-color: #f2f9ff;
		.loaderbox{
			width: 100%;
			flex-wrap: wrap;
			margin: 2rem 0;
			.loaderimg{
				width: 30%;
				padding: 15% 0;
				margin-right: 5%;
				position: relative;
				margin-bottom: 1.5rem;
				.pos{
					position: absolute;
					top:0;
					left:0;
					bottom:0;
					right:0;
					.del{
						position: absolute;
						right:-0.6rem;
						top:-0.6rem;
						font-size: 2rem;
						z-index: 99;
						color: rgba(0,0,0,.5);
					}
				}
				&:nth-child(3n){
					margin-right: 0;
				}
			}
		}
		.submit{
			width: 100%;
			background-color: #fa6b6b;
			border: 0;
			margin-bottom: 2rem;
		}
		.uploadbox {
			.Positive {
				width: 100%;
				font-size: 0;
				box-shadow: 0 3px 8px 1px #e8eaee;
			}
			.verso{
				width: 100%;
				font-size: 0;
				margin-bottom: 3rem;
			}
		}

		.imgbox {
			.title {
				margin-bottom: 1.5rem;

				.p1 {
					font-weight: bold;
					color: #161616;
					font-size: 1.8rem;
					line-height: 2.5rem;
				}

				.p2 {
					color: #999999;
					font-size: 1.4rem;
					line-height: 2rem;
				}
			}
		}

		.step {
			margin: 1rem 0;
			.box {
				font-size: 1.3rem;
				text-align: center;

				.icon {
					font-size: 1.9rem;
					margin-bottom: 0.2rem;
				}
			}
		}
	}
</style>
